import React, { useMemo } from "react";
import ReactHtmlParser from "react-html-parser";
import { useState } from "./hooks/useState";
import useCMS from "./hooks/useCMS";

function PersonalNumberDetails() {
  const cmsData = useCMS();
  const { formType, personalNumber } = useState();
  const type = useMemo(() => {
    if (formType === "RecoveryVab" || formType === "RecoverySick")
      return "Recovery";
    return formType;
  }, [formType]);

  return (
    <div className="content">
      <div className="box info-box">
        <h3>
          {cmsData[type].headline} {personalNumber}
        </h3>
        {cmsData[type].information &&
          ReactHtmlParser(cmsData[type].information)}
      </div>
    </div>
  );
}

export default PersonalNumberDetails;
